export interface ToyRelease {
  date: string;
  time: string | null;
  localTime: string | null;
  brand: string;
  toyLine: string;
  note: string | null;
  source: string;
  sourceUrl: string | null;
  imageUrl: string | null;
  price: string | null;
  firstSeenAt?: string | null;
  // Stable server identity (the release's DedupeKey / DB primary key). Used as the target
  // for per-release notification subscriptions. May be absent on older cached payloads.
  key?: string;
  // Absolute epoch-ms instant the release becomes available (Date + Time resolved to UTC),
  // computed client-side during enrichment. Null when there is no concrete parseable time.
  // Drives the "future only" gating of both the timestamp display and the availability bell.
  availableAt?: number | null;
}

// True when the release has a concrete availability instant that is still in the future.
// Single source of truth for gating both the release timestamp and the availability bell, so
// the two always agree. Releases without a parseable time (availableAt null/undefined) are not
// considered upcoming.
export function isReleaseUpcoming(release: ToyRelease, now: number = Date.now()): boolean {
  return typeof release.availableAt === 'number' && release.availableAt > now;
}
